import React from 'react';
import PropTypes from 'prop-types';
import I18n from 'i18n-js';
import ActionBar from 'shared/LessonOverview/Cards/ActionBar';
import useFlags from '@/hooks/useFlags';
import teacherCardStyles from 'shared/LessonOverview/Staffer/teacherCardStyles';
import styles from 'shared/LessonOverview/Staffer/TeacherCard.module.scss';

function TeacherCard({ slideShow, programId, lessonId }) {
  const { accessibilityReflow } = useFlags();
  const { header, root, title } = teacherCardStyles({ reflow: accessibilityReflow });

  return (
    <div className={root()}>
      <div className={styles.banner}>
        {I18n.t(slideShow.activityType).toUpperCase()}
      </div>
      <div className={header()}>
        {renderThumbnail(slideShow)}
        <div className={title()}>
          <a href={slideShow.links.presentPath} rel="noopener noreferrer" target="_blank">{slideShow.truncatedTitle}</a>
        </div>
      </div>

      <ActionBar
        isStaffer={false}
        lessonId={lessonId}
        programId={programId}
        slideShow={slideShow}
      />
    </div>
  );
}

function renderThumbnail(slideShow) {
  if (slideShow.staffer_initials) {
    return (
      <div className={styles.thumbnail}>
        {slideShow.staffer_initials}
      </div>
    );
  }

  return <div className={`${styles.thumbnail} ${styles.tciAvatar} tci-logo-white`} />;
}

TeacherCard.propTypes = {
  lessonId: PropTypes.string.isRequired,
  programId: PropTypes.string.isRequired,
  slideShow: PropTypes.shape({
    activityType: PropTypes.string,
    links: PropTypes.shape({
      presentPath: PropTypes.string.isRequired
    }),
    staffer_initials: PropTypes.string,
    truncatedTitle: PropTypes.string.isRequired,
  })
};

TeacherCard.defaultProps = {
  slideShow: {
    staffer_initials: null,
  }
};

export default TeacherCard;
